// 운영 관리 왼쪽 메뉴 데이터와 최고관리자 판정. 규격: docs/superpowers/specs/2026-09-14-ops-auth-toss.md D3.
//
// OpsLayout.js 와 별도 파일에 둔다 — NavigationBar.js 가 이 파일의 OPS_NAV 를 상단
// "운영 관리" 링크의 활성 표시 판정에 쓰고, OpsLayout 은 NavigationBar 를 불러오므로
// 한 파일에 두면 순환 import 가 된다.
//
// 메뉴 항목과 최고관리자 걸림을 여기 한 곳에 둔다. 예전에는 NavigationBar 의 호버
// 하위 메뉴에 11개가 흩어져 있었고, 그룹 화면 두 쌍을 합치며 9개가 됐다(D1·D2) —
// 그 호버 하위 메뉴는 이후 걷어내고 "운영 관리" 입구 링크 하나로 바꿨다(NavigationBar.js).
export const OPS_NAV = [
    {
        group: '계정 · 권한',
        strong: true,
        items: [
            // 2026-09-16 결정: 이 네 화면은 최고관리자 전용이다. 일반 관리자가 관리자
            // 그룹에 사람을 넣거나 화면 권한 규칙을 바꿀 수 있으면 승인 절차가 의미를
            // 잃는다. 서버도 같은 경로를 막는다(src/server/adminScope/gate.js 의
            // SUPER_ADMIN_ONLY_ROUTES) — 메뉴만 가리면 주소를 직접 쳤을 때 열린다.
            { to: '/Operations', label: '관리자 관리', superAdmin: true },
            { to: '/AdminApprovals', label: '관리자 가입 승인', superAdmin: true },
            { to: '/AdminGroups', label: '관리자 그룹 관리', superAdmin: true },
            { to: '/AdminScreens', label: '화면 권한 관리', superAdmin: true }
        ]
    },
    {
        group: '사용자',
        strong: true,
        items: [{ to: '/UserGroups', label: '사용자 그룹 관리' }]
    },
    {
        group: '주치의',
        items: [
            { to: '/DoctorManagement', label: '주치의 관리' },
            { to: '/DoctorApplications', label: '주치의 신청/조회' }
        ]
    },
    {
        group: '결제 · 회원',
        strong: true,
        items: [
            { to: '/SafePackageList', label: '안심패키지 신청 조회 및 수락', superAdmin: true },
            { to: '/UserWithdrawManagement', label: '사용자 탈퇴 관리', superAdmin: true },
            { to: '/PackagePurchaseManagement', label: '패키지 구매 관리', superAdmin: true }
        ]
    },
    {
        // 2026-09-23: 기관 마스터(/hos)와 월간 보고서(/gro)를 메뉴에 노출한다.
        // 두 화면 모두 최고관리자 전용이라 항목에 superAdmin 을 건다(각 페이지도
        // isSuperAdmin 으로 자체 차단한다). 예전에는 주소로만 들어가게 숨겨 뒀다.
        group: '운영',
        strong: true,
        items: [
            { to: '/hos', label: '기관 추가', superAdmin: true },
            { to: '/gro', label: '월간 보고서', superAdmin: true },
            // 2026-11-02: 공지 푸시. 서버(src/server/announcements/router.js)도 SUPER_ADMIN 만 통과시킨다.
            { to: '/PushAnnouncements', label: '공지 푸시', superAdmin: true }
        ]
    }
];

/**
 * 상단 '운영 관리' 를 눌렀을 때 갈 첫 화면. 그 사람이 열 수 있는 첫 항목이다.
 *
 * ⚠️ 고정으로 /Operations 를 가리키면 안 된다. 2026-09-16 에 그 화면이 최고관리자
 *    전용이 되면서, 일반 관리자는 눌러도 관제센터로 되돌려져 왼쪽 메뉴를 볼 기회조차
 *    없었다(2026-09-17 보고). 메뉴가 늘거나 권한이 바뀌어도 여기 한 곳만 맞으면 된다.
 */
export const opsLandingPath = (superAdmin) => {
    const first = OPS_NAV.flatMap((group) => group.items).find((item) => !item.superAdmin || superAdmin);
    return first ? first.to : '/ControlCenter';
};

// 왼쪽 메뉴에서 superAdmin 항목을 거르는 데만 쓴다(OpsLayout.js 가 부른다) — NavigationBar.js
// 는 이 함수를 부르지 않는다. localStorage 의 is_super_admin/adminInfo.is_super_admin 을
// 직접 읽는 판정은 여러 운영 화면(PackagePurchaseManagement.js 등)이 자기 안에서도 따로
// 하고 있다. 권한 계산을 서버로 옮기는 일은 이 계획 밖이다.
export const isSuperAdminSession = () => {
    let adminInfo = {};
    try {
        adminInfo = JSON.parse(localStorage.getItem('adminInfo') || '{}') || {};
    } catch (e) {
        adminInfo = {};
    }
    return localStorage.getItem('is_super_admin') === 'true' || adminInfo.is_super_admin === true;
};
